<template>
  <div class="news-module">
    <div class="news-module__box">
      <div class="news-module__header">
        <div class="news-header__title">
          <span class="news-title">新闻资讯</span>
          <a class="news-title__right" @click="handleMoreNews">更多资讯<i class="el-icon-arrow-right" style="margin-left: 20px;"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewsList",
  data() {},
  methods: {
    handleMoreNews() {
      alert('更多信息')
    }
  }
}
</script>
<style scoped>
.news-module {
  background-color: #dee7f8;
  width: 100%;
  height: auto;
}
.news-module__box {
  height: 500px;
  text-align: center;
  padding: 20px;
  margin: 25px auto auto;
}
.news-module__header .news-header__title {
  width: 1140px;
  margin: auto;
  text-align: center;
  margin-top: 30px;
}
.news-module__header .news-header__title .news-title {
  font-size: 36px;
  color: #150e52;
  font-weight: 600;
}
.news-module__header .news-header__title .news-title__right {
  float: right;
  border-bottom: 0.125rem solid #0d7dfc;
  line-height: 1.875rem;
  font-weight: 400;
  color: #1d1f24;
  //margin-right: 30px;
}
</style>
